module.exports = __webpack_public_path__ + "img/calender.5a8a392b.svg";